import { useLocation, useOutletContext } from 'react-router-dom'

import Templates from 'modules/reports/components/Templates'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'

const TemplatesPage = () => {
  const { back, loading } = useOutletContext<RouteContextParams>()
  const location = useLocation()
  const selected = new URLSearchParams(location.search).get('selected')

  return <Templates selectedCategory={selected} back={back} loading={loading} />
}

export default TemplatesPage
